module.exports = __webpack_public_path__ + "img/arrow-up.85d5ec1c.svg";